import { gql } from '@apollo/client'

const LOCATION_NAMES_QUERY = gql`
  query locationNamesQuery($menuId: ID!) {
    locationNames(menuId: $menuId) {
      id
      name
    }
  }
`

export default LOCATION_NAMES_QUERY
